angular.module('app').factory('mobileConfigsService', [
    'Restangular',
    'settings',
    'userStorage',
    function (Restangular, settings, userStorage) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var configs = restAngular.all("/config/");

        return {
            getConfigsMenu: function (requestData) {
                if (requestData) {
                    return configs.
                    one("getMobile").
                    customGET(param(requestData));
                }
                return configs.
                one("getMobile").
                get();
            },
            getConfigByConfigSkinId: function (configId) {
                return configs.
                one("getMobile").
                get({config_id: configId})
            },
            deleteConfig: function (requestData) {
                return configs.
                one("deleteMobileConfig").
                customGET(param(requestData))
            },
            deleteSkinConfig: function (requestData) {
                return configs.
                one("deleteMobileSkinConfig").
                customGET(param(requestData))
            },
            updateConfigByConfigSkinId: function (configData) {
                return configs.
                one("changeMobile").
                post("", {config: configData})
            },
            generateJs: function (requestData) {
                requestData = requestData || {};
                return configs.
                one("generateMobileJS").
                customGET(param(requestData))
            },
            createConfig: function (configData) {
                return configs.
                one("createMobile").
                post("", {config: configData})
            },
            editConfig: function (configData) {
                return configs.
                one("changeMobileTree").
                post("", {config: configData})
            },
            getConfigTypes: function () {
                return configs.
                one("getTypes").
                get()
            },
            searchConfig: function (requestConfig) {
                return configs.
                one("searchMobileConfig").
                customGET(param(requestConfig))
            },
            searchConfigSkin: function (requestConfig) {
                return configs.
                one("searchMobileConfigSkin").
                customGET(param(requestConfig))
            },
            applyConfigs: function (requestData) {
                if (userStorage.getUserData().permissions.indexOf('viewSkins') !== -1 ) {
                    return configs.
                    one("applyMobileAll").
                    get()
                }
                return configs.
                one("applyMobile").
                post("", requestData)
            },
            applyConfigsBySkinId : function (requestData) {
                return configs.
                one("applyMobile").
                post("", requestData)
            },
            applyPayments: function (requestData) {
                return configs.
                one("applyMobile").
                post("", requestData)
            },
            addConfigsSkins: function (requestData) {
                return configs.
                one("addMobileConfigsSkins").
                post("", requestData)
            },
            getVersionsBySkinId: function (skinId) {
                return configs.
                one("getMobileSkinConfigVersions").
                get({skin_id: skinId})
            },
            revertConfigVersion: function (configVersionId, message) {
                var requestData = {
                    initial_version_id: configVersionId,
                    message: message
                };
                return configs.
                one("revertMobileSkinConfigVersion").
                post("", {revertSkinConfig: requestData})
            },
            duplicateConfig: function (requestData) {
                return configs.
                one("duplicateMobileConfig").
                customGET(param(requestData))
            },
            generateSkinConfigs: function(requestData){
                return configs.
                one("generateMobileSkinConfigs").
                customGET(param(requestData))
            },
            uploadMobileConfJson: function (requestData) {
                return configs.
                       one("uploadMobileConfJson").
                       post("",  requestData)
            }
        }
    }
]);
